/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'dashboard': {
    width: 32,
    height: 32,
    viewBox: '0 0 1024 1024',
    data: '<path pid="1899" d="M192 736 192 416C192 261.184 301.952 132.064 448 102.4L448 64C448 28.64 476.64 0 512 0 547.36 0 576 28.64 576 64L576 102.4C722.048 132.064 832 261.184 832 416L832 736 864.096 736C899.392 736 928 764.416 928 800 928 835.36 899.36 864 864.096 864L159.904 864C124.608 864 96 835.584 96 800 96 764.64 124.64 736 159.904 736L192 736ZM608 928C608 981.024 565.024 1024 512 1024 458.976 1024 416 981.024 416 928L608 928Z"/>'
  }
})
